import { ReviewCompletionTimeGraph } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/ReviewCompletionTime/ReviewCompletionTimeGraph";
import { ReviewCompletionTimeRawData } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/ReviewCompletionTime/ReviewCompletionTimeRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

export const ReviewCompletionTime = () => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>{selectedDialogTab === "Raw Data" ? <ReviewCompletionTimeRawData /> : <ReviewCompletionTimeGraph />}</div>
  );
};
